export class Budget {
  daily: number;
  lifetime: number;

  constructor() {
    this.daily = null;
    this.lifetime = null;
  }
}

export class BdspFrequencyCap {
  interval: "day" | "hour" | "week";
  duration: number;
  imps: number;

  constructor() {
    this.interval = "day";
    this.duration = 1;
    this.imps = 6;
  }
}

export class BdspActiveFlight {
  start_date;
  end_date;
  budget: number;
  daily_budget: number;
  disable_start_date: boolean;
  disable_end_date: boolean;

  constructor() {
    this.disable_start_date = false;
    this.disable_end_date = false;
    this.budget = null;
    this.daily_budget = null;
  }
}

export class BdspBiddingValues {
  cpa_target: number;
  max_bid: number;
  cpm_bid: number;
  ecpc_target: number;
  cpa_event;
  target_vcr: number;

  constructor() {
    this.cpa_target = 0.1;
    this.max_bid = 0.1;
    this.cpm_bid = 0.1;
    this.ecpc_target = 0.1;
    this.cpa_event = "";
    this.target_vcr = 0.1;
  }
}
export class BdspBidding {
  strategy: "cpm_paced" | "cpa_paced" | "cpc_paced" | "vcr_paced" | "flat_cpm";
  values: BdspBiddingValues;
  pacing: "daily_even" | "daily_ahead" | "lifetime_ahead" | "lifetime_even";
  multiplier: number;

  constructor() {
    this.strategy = "cpm_paced";
    this.values = new BdspBiddingValues();
    this.pacing = "lifetime_even";
    this.multiplier = 1;
  }
}

export class LatLongList {
  lat_long_list_id;
  lat_long_list_action: string;

  constructor() {
    this.lat_long_list_action = "include";
  }
}
export class Geography {
  region_action: string;
  metro_action: string;
  city_action: string;
  country_action: string;
  zip_action: string;

  country: Array<any>;
  city: Array<any>;
  region: Array<any>;
  zip: Array<any>;
  metro: Array<any>;
  lat_long_list: Array<LatLongList>;

  constructor() {
    this.country = [];
    this.city = [];
    this.region = [];
    this.zip = [];
    this.metro = [];

    this.region_action = "";
    this.metro_action = "";
    this.city_action = "";
    this.country_action = "";
    this.zip_action = "include";
    this.lat_long_list = [];
  }
}

export class Domain {
  domain_list_id;
  domain_list_action: string;

  constructor() {
    this.domain_list_action = "include";
  }
}

export class AppBundle {
  app_bundle_list_id;
  app_bundle_list_action: string;

  constructor() {
    this.app_bundle_list_action = "include";
  }
}

export class Deal {
  deal_id;
  deal_action: string;

  constructor() {
    this.deal_action = "include";
  }
}

export class AppSite {
  placement: Array<any>;
  domains: Array<Domain>;
  deals: Array<Deal>;
  app_bundle: Array<AppBundle>;
  placement_action: string;

  constructor() {
    this.placement = [];
    this.domains = [];
    this.app_bundle = [];
    this.deals = [];
    this.placement_action = "include";
  }
}

export class Segment {
  segment_type: string;
  segment_action: string;
  id;

  constructor() {}
}
export class User {
  segment: Array<Segment>;
  user_id_present: string;
  opt_user_id: boolean;

  constructor() {
    this.segment = [];
    this.user_id_present = "include";
    this.opt_user_id = false;
  }
}

export class Environment {
  environment_type: Array<any>;
  environment_type_action: string;
  ads_txt: Array<any>;
  ads_txt_action: string;
  native_layout: Array<any>;
  native_layout_action: string;
  ad_position: Array<string>;
  ad_position_action: string;
  interstitial_type: Array<string>;
  interstitial_type_action: string;
  rewarded: string;

  constructor() {
    this.environment_type = ["in_app", "web"];
    this.environment_type_action = "include";
    this.ads_txt = [];
    this.ads_txt_action = "include";
    this.native_layout = [];
    this.native_layout_action = "include";
    this.ad_position = [];
    this.ad_position_action = "include";
    this.interstitial_type = [];
    this.interstitial_type_action = null;
    this.rewarded = null;
  }
}

export class Platform {
  device_type: Array<any>;
  device_type_action: string;
  operating_system: Array<any>;
  operating_system_action: string;

  constructor() {
    this.device_type = ["desktop", "mobile", "tablet"];
    this.device_type_action = "include";
    this.operating_system = [];
    this.operating_system_action = "include";
  }
}

export class userTime {
  user_time_of_week: Array<any>;
  user_time_of_week_action: string;

  constructor() {
    this.user_time_of_week = [];
    this.user_time_of_week_action = "include";
  }
}

export class ContentCategory {
  content_category_id;
  content_category_action: string;

  constructor() {}
}

export class Language {
  name: string;
  key: string;
}

export class Content {
  content_category: Array<ContentCategory>;
  language: Array<Language>;
  language_action: string;

  constructor() {
    this.content_category = [];
    this.language = [];
    this.language_action = "include";
  }
}

export class Video {
  is_companion_opted: boolean;
  companion_required: string;
  player_size: Array<any>;
  player_size_action: string;
  start_delay: Array<any>;
  start_delay_action: string;
  video_placement_type: Array<any>;
  video_placement_type_action: string;
  playback_method: Array<any>;
  playback_method_action: string;

  constructor() {
    this.is_companion_opted = false;
    this.companion_required = "include";
    this.player_size = [];
    this.player_size_action = "include";
    this.start_delay = [];
    this.start_delay_action = "include";
    this.video_placement_type = [];
    this.video_placement_type_action = "include";
    this.playback_method = [];
    this.playback_method_action = "include";
  }
}

export class Audio {
  audio_start_delay: Array<any>;
  audio_start_delay_action: string;

  constructor() {
    this.audio_start_delay = [];
    this.audio_start_delay_action = "include";
  }
}

export class BdspTargeting {
  geo: Geography;
  app_site: AppSite;
  user: User;
  environment: Environment;
  platform: Platform;
  time: userTime;
  content: Content;
  video: Video;
  audio: Audio;

  constructor() {
    this.geo = new Geography();
    this.app_site = new AppSite();
    this.user = new User();
    this.environment = new Environment();
    this.platform = new Platform();
    this.time = new userTime();
    this.content = new Content();
    this.video = new Video();
    this.audio = new Audio();
  }
}

export class SegmentExtension {
  extension_type: string;
  segment_type: string;
  vendor: string;

  constructor() {
    this.extension_type = "person";
    this.segment_type = "all";
    this.vendor = "freewheel";
  }
}
export class BdspLineItem {
  name: string;
  description: string;
  state: "active" | "inactive";
  type:
    | "banner"
    | "video"
    | "native_banner"
    | "native_video"
    | "audio"
    | "html5"
    | "connected_tv"
    | "audio";
  budget: Budget;
  start_date;
  end_date;
  active_flights: Array<BdspActiveFlight>;
  use_fallback: boolean;
  frequency_caps: Array<BdspFrequencyCap>;
  bidding: BdspBidding;
  creatives: Array<any>;
  creative_weights: Record<number, number>;
  delivery_modifier: string;
  events: Array<any>;
  targeting: BdspTargeting;
  disable_start_date: boolean;
  delivery_modifiers;
  enable_segment_extension: boolean;
  segment_extension: SegmentExtension;

  constructor() {
    this.name = "";
    this.description = "";
    this.state = "inactive";
    this.type = "banner";
    this.budget = new Budget();
    this.active_flights = [];
    this.bidding = new BdspBidding();
    this.frequency_caps = [];
    this.creatives = [];
    this.creative_weights = {};
    this.delivery_modifier = "";
    this.events = [];
    this.targeting = new BdspTargeting();
    this.use_fallback = false;
    this.disable_start_date = false;
    this.segment_extension = new SegmentExtension();
    this.enable_segment_extension = false;
  }
}

export class LIAssoc {
  events: Array<any>;
  creatives: Array<any>;
  delivery_modifier: Array<any>;
  creative_weights: Record<number, number>;

  constructor() {
    this.events = [];
    this.creatives = [];
    this.delivery_modifier = [];
    this.creative_weights = {};
  }
}

export class GeoObj {
  id: string;
  name: string;
}

export class RegionObject {
  region: GeoObj;
  region_included: boolean;
  cities: Array<GeoObj>;

  constructor() {
    this.cities = [];
    this.region_included = true;
  }
}
export class CountryObject {
  country: GeoObj;
  country_included: boolean;
  regions: Array<RegionObject>;

  constructor() {
    this.regions = [];
    this.country_included = true;
  }
}

export class isValid {
  li_basic_setup: boolean;
  li_creative_setup: boolean;
  li_targeting: boolean;
  li_dlv_modifiers: boolean;

  constructor() {
    this.li_basic_setup = true;
    this.li_targeting = true;
    this.li_creative_setup = true;
    this.li_dlv_modifiers = true;
  }
}

export const lineItemTypes = [
  { label: "Banner", value: "banner" },
  { label: "Video", value: "video" },
  { label: "HTML5", value: "html5" },
  { label: "Audio", value: "audio" },
  { label: "Connected TV", value: "connected_tv" },
  { label: "Native Banner", value: "native_banner" },
  { label: "Native Video", value: "native_video" },
];

export const strategyTypes = {
  banner: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "CPA", value: "cpa_paced", toolTip: "" },
  ],
  video: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "VCR", value: "vcr_paced", toolTip: "" },
  ],
  html5: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "CPA", value: "cpa_paced", toolTip: "" },
  ],
  connected_tv: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "VCR", value: "vcr_paced", toolTip: "" },
  ],
  audio: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "CPA", value: "cpa_paced", toolTip: "" },
  ],
  native_banner: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "CPA", value: "cpa_paced", toolTip: "" },
  ],
  native_video: [
    { label: "CPM", value: "cpm_paced", toolTip: "" },
    { label: "CPC", value: "cpc_paced", toolTip: "" },
    { label: "VCR", value: "vcr_paced", toolTip: "" },
  ],
  pg: [{ label: "Flat CPM", value: "flat_cpm", toolTip: "" }],
};

export const pacingOptions = [
  { label: "Flight Even", value: "lifetime_even", toolTip: "" },
  { label: "Flight ASAP", value: "lifetime_ahead", toolTip: "" },
  { label: "Daily Even", value: "daily_even", toolTip: "" },
  { label: "Daily ASAP", value: "daily_ahead", toolTip: "" },
];

export interface targetingUpdateRequest {
  add: BdspTargeting;
  remove: BdspTargeting;
  remove_all: Array<any>;
}

export interface UpdateRequest {
  add: Array<any>;
  remove: Array<any>;
  remove_all: boolean;
}

export interface bulkUpdateEditableFields {
  start_date?: string;
  end_date?: string;
  budget?: Budget;
  use_fallback?: boolean;
  bidding?: BdspBidding;
  frequency_caps?: Array<BdspFrequencyCap>;
  events?: UpdateRequest;
  creatives?: UpdateRequest;
  targeting?: targetingUpdateRequest;
}

export interface bulkUpdatePayload {
  li_ids: Array<any>;
  edited_fields: bulkUpdateEditableFields;
}

export const liBulkUploadPayload: bulkUpdatePayload = {
  li_ids: [],
  edited_fields: {
    start_date: "",
    end_date: "",
    budget: {
      daily: null,
      lifetime: null,
    },
    bidding: {
      strategy: "cpm_paced",
      values: {
        cpa_target: 0.1,
        max_bid: 0.1,
        cpm_bid: 0.1,
        ecpc_target: 0.1,
        cpa_event: "",
        target_vcr: 0.1,
      },
      pacing: "lifetime_even",
      multiplier: 1
    },
    events: {
      add: [],
      remove: [],
      remove_all: false,
    },
    creatives: {
      add: [],
      remove: [],
      remove_all: false,
    },
    targeting: {
      add: {
        geo: {
          region_action: "include",
          metro_action: "include",
          city_action: "include",
          country_action: "include",
          zip_action: "include",

          country: [],
          city: [],
          region: [],
          zip: [],
          metro: [],
          lat_long_list: []
        },
        app_site: {
          placement: [],
          domains: [],
          app_bundle: [],
          placement_action: "include",
          deals: [],
        },
        user: {
          segment: [],
          user_id_present: "",
          opt_user_id: false,
        },
        environment: {
          environment_type: [],
          environment_type_action: "include",
          ads_txt: [],
          ads_txt_action: "include",
          native_layout: [],
          native_layout_action: "include",
          ad_position: [],
          ad_position_action: "include",
          interstitial_type: [],
          interstitial_type_action: null,
          rewarded: null,
        },
        platform: {
          device_type: [],
          operating_system: [],
          device_type_action: "include",
          operating_system_action: "include",
        },
        time: {
          user_time_of_week: [],
          user_time_of_week_action: "include",
        },
        content: {
          content_category: [],
          language: [],
          language_action: "include"
        },
        video: {
          is_companion_opted: false,
          companion_required: "",
          player_size: [],
          player_size_action: "include",
          start_delay: [],
          start_delay_action: "include",
          video_placement_type: [],
          video_placement_type_action: "include",
          playback_method: [],
          playback_method_action: "include",
        },
        audio: {
          audio_start_delay: [],
          audio_start_delay_action: "include",
        },
      },
      remove: {
        geo: {
          region_action: "",
          metro_action: "",
          city_action: "",
          country_action: "",
          zip_action: "",

          country: [],
          city: [],
          region: [],
          zip: [],
          metro: [],
          lat_long_list: []
        },
        app_site: {
          placement: [],
          domains: [],
          app_bundle: [],
          placement_action: "include",
          deals: [],
        },
        user: {
          segment: [],
          user_id_present: "",
          opt_user_id: false,
        },
        environment: {
          environment_type: [],
          environment_type_action: "include",
          ads_txt: [],
          ads_txt_action: "include",
          native_layout: [],
          native_layout_action: "include",
          ad_position: [],
          ad_position_action: "include",
          interstitial_type: [],
          interstitial_type_action: null,
          rewarded: null,
        },
        platform: {
          device_type: [],
          operating_system: [],
          device_type_action: "include",
          operating_system_action: "include",
        },
        time: {
          user_time_of_week: [],
          user_time_of_week_action: "include",
        },
        content: {
          content_category: [],
          language: [],
          language_action: "include"
        },
        video: {
          is_companion_opted: false,
          companion_required: "",
          player_size: [],
          player_size_action: "include",
          start_delay: [],
          start_delay_action: "include",
          video_placement_type: [],
          video_placement_type_action: "include",
          playback_method: [],
          playback_method_action: "include",
        },
        audio: {
          audio_start_delay: [],
          audio_start_delay_action: "include",
        },
      },
      remove_all: [],
    },
  },
};

export const segmentExtensionVendor: Array<Object> = [
  {
    label: "Freewheel ID Network (Available only in the US)",
    value: "freewheel",
  },
  { label: "Liveramp", value: "liveramp" },
];

export const segmentExtenstionType: Array<string> = [
  "person",
  "household",
  "person_extend_only",
  "household_extend_only",
];

export const segmentType: Array<Object> = [
  { value: "all", label: "All" },
  { value: "1st_party", label: "My Segments" },
  { value: "3rd_party", label: "Third Party" },
];

export const allowCPMBid: ReadonlySet<string> = new Set([
  "cpm_paced",
  "vcr_paced",
  "flat_cpm",
]);

export const allowMaxBid: ReadonlySet<string> = new Set([
  "cpc_paced",
  "cpa_paced",
]);

export const nativeTypes: ReadonlySet<string> = new Set([
  "native_banner",
  "native_video",
]);

export const videoTypes: ReadonlySet<string> = new Set([
  "video",
  "native_video",
  "connected_tv",
]);

export const pacingMappings: Record<string, string> = {
    daily_even: 'Daily Even',
    daily_ahead: 'Daily Ahead',
    lifetime_ahead: 'Flight ASAP',
    lifetime_even: 'Flight Even',
};

export const adPositionList = [
    { key: 'below_the_fold', name: 'Below The Fold'},
    { key: 'above_the_fold', name: 'Above The Fold'},
    { key: 'footer', name: 'Footer' },
    { key: 'header', name: 'Header' },
    { key: 'sidebar', name: 'Sidebar' },
    { key: 'full_screen', name: 'Full Screen' },
    { key: 'unknown', name: 'Unknown' },
];

export const interstitialTypes = [
    { key: 'banner', name: 'Banner'},
    { key: 'video', name: 'Video'},
];

export const STATIC_LISTING_MAPS = {
  ad_position: adPositionList,
  interstitial_type: interstitialTypes,
}

export const resetMap: Record<string, Partial<BdspBiddingValues>> = {
  cpm_paced: {
    cpa_event: "",
    cpa_target: 0.1,
    max_bid: 0.1,
    target_vcr: 0.1,
    ecpc_target: 0.1,
  },
  cpa_paced: {
    ecpc_target: 0.1,
    cpm_bid: 0.1,
    target_vcr: 0.1,
  },
  vcr_paced: {
    cpa_event: "",
    cpa_target: 0.1,
    ecpc_target: 0.1,
    max_bid: 0.1,
  },
  cpc_paced: {
    cpa_event: "",
    cpa_target: 0.1,
    cpm_bid: 0.1,
    target_vcr: 0.1,
  },
  flat_cpm: {
    cpa_event: "",
    cpa_target: 0.1,
    target_vcr: 0.1,
    ecpc_target: 0.1,
    max_bid: 0.1,
  },
};

export const GamblingId = "IAB19_29";
